"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __exportStar = (this && this.__exportStar) || function(m, exports) {
    for (var p in m) if (p !== "default" && !Object.prototype.hasOwnProperty.call(exports, p)) __createBinding(exports, m, p);
};
Object.defineProperty(exports, "__esModule", { value: true });
__exportStar(require("./schemas/concession-card"), exports);
__exportStar(require("./schemas/immediate-nurse-consult"), exports);
__exportStar(require("./schemas/patient"), exports);
__exportStar(require("./schemas/prescription"), exports);
__exportStar(require("./schemas/prescription-sync-queue-message"), exports);
//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoiaW5kZXguanMiLCJzb3VyY2VSb290IjoiIiwic291cmNlcyI6WyIuLi8uLi9zcmMvZXZlbnRzL2luZGV4LnRzIl0sIm5hbWVzIjpbXSwibWFwcGluZ3MiOiI7Ozs7Ozs7Ozs7Ozs7Ozs7QUFBQSw0REFBMEM7QUFDMUMsb0VBQWtEO0FBQ2xELG9EQUFrQztBQUNsQyx5REFBdUM7QUFDdkMsNEVBQTBEIiwic291cmNlc0NvbnRlbnQiOlsiZXhwb3J0ICogZnJvbSAnLi9zY2hlbWFzL2NvbmNlc3Npb24tY2FyZCc7XG5leHBvcnQgKiBmcm9tICcuL3NjaGVtYXMvaW1tZWRpYXRlLW51cnNlLWNvbnN1bHQnO1xuZXhwb3J0ICogZnJvbSAnLi9zY2hlbWFzL3BhdGllbnQnO1xuZXhwb3J0ICogZnJvbSAnLi9zY2hlbWFzL3ByZXNjcmlwdGlvbic7XG5leHBvcnQgKiBmcm9tICcuL3NjaGVtYXMvcHJlc2NyaXB0aW9uLXN5bmMtcXVldWUtbWVzc2FnZSc7XG4iXX0=